export default {
  routes: [
    {
      name: 'nodeTypes',
      path: '/admin/node-types',
      component: () => import('./views/TheNodeTypes.vue'),
    },
    {
      name: 'nodeType',
      path: '/admin/node-types/:uuid',
      component: () => import('./views/TheNodeType.vue'),
    },
  ]
}
